import { StoreProvider as SProvider, useStoreRehydrated } from "easy-peasy";
import * as React from "react";
import { store } from "../store";
export var StoreProvider = function StoreProvider(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ React.createElement(SProvider, {
        store: store
    }, /*#__PURE__*/ React.createElement(WaitForStateRehydration, null, children));
};
export var RehydrationContext = /*#__PURE__*/ React.createContext(false);
var WaitForStateRehydration = function WaitForStateRehydration(_ref2) {
    var children = _ref2.children;
    var isRehydrated = useStoreRehydrated();
    return /*#__PURE__*/ React.createElement(RehydrationContext.Provider, {
        value: isRehydrated
    }, children);
};
